<template>
  <div class="list-table outside">
    <div class="scroll-table" v-if="!isMobile">
      <table class="main-table">
        <thead>
          <!-- <th>
            <input type="checkbox" class="checkbox" v-model="checkAll" @change="toggleCheckAll" />
          </th> -->
          <th :class="{'sortable':true, 'active':currentOrder.field === 'name'}"
            @click="sort('name')">
            {{ $t('provider.availability.businessName') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'name'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'license'}"
            @click="sort('license')">
            {{ $t('provider.availability.type') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'license'"></i>
          </th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'sector'}"
            @click="sort('sector')">
            {{ $t('provider.availability.homeSector') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'sector'"></i>
          </th>
          <th>Service</th>
          <th :class="{'sortable':true, 'active':currentOrder.field === 'vehicle'}"
            @click="sort('vehicle')">
            {{ $t('provider.availability.vehicle') }}
            <i :class="['fas', currentOrder.asc ? 'fa-caret-up' : 'fa-caret-down']"
              v-show="currentOrder.field === 'vehicle'"></i>
          </th>
          <th>{{ $t('provider.availability.phone') }}</th>
        </thead>
        <tbody>
          <tr v-for="(user, index) in users" :key="index" v-show="showDriver(index)">
            <!-- <td>
              <input type="checkbox" class="checkbox" 
              :value="user.id" v-model="checked" />
            </td> -->
            <td>
              <a v-bind:href="'/#/provider/' + user.id" target="_blank">{{ user.name }}</a>
            </td>
            <td><span :class="['type', user.licenseType]">{{ user.licenseType }}</span></td>
            <td class="home-sector">{{ user.homeSector }}</td>
            <td class="pax-dtd">{{ user.paxDtd }}</td>
            <td class="vehicle-type">{{ user.vehicleType }}</td>
            <td class="mobile">
              <a @click="call(user)">{{ user.mobile }}</a>
            </td>
          </tr>

          <tr v-show="loading && users.length === 0">
            <td colspan="7" class="table-block">
              <transition name="slide-up">
                <div v-show="loading" class="loader">
                  <i class="fas fa-spinner fa-spin"></i>
                  {{ $t('consumer.list.gettingUsers') }}
                </div>
              </transition>
            </td>
          </tr>

          <tr v-show="users.length === 0 && !loading">
            <td colspan="7" class="table-block">
              <transition name="slide-up">
                <div v-show="users.length === 0 && !loading" class="empty-result">
                  <i class="far fa-frown-open fa-3x"></i><br/>
                  No record found!~
                </div>
              </transition>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="cards" v-else>
      <div v-show="loading && users.length === 0" class="result-stat">
        <transition name="slide-up">
          <div v-show="loading" class="loader">
            <i class="fas fa-spinner fa-spin"></i>
            {{ $t('consumer.list.gettingUsers') }}
          </div>
        </transition>
      </div>

      <div v-show="users.length === 0 && !loading" class="result-stat">
        <transition name="slide-up">
          <div v-show="users.length === 0 && !loading" class="empty-result">
            <i class="far fa-frown-open fa-3x"></i><br/>
            No record found!
          </div>
        </transition>
      </div>
      <div class="card" v-for="(user, index) in users" :key="index">

        <div class="card-header">
          <input type="checkbox" class="checkbox" :value="user.id" v-model="checked" />
          <span :class="['type', user.licenseType]">{{ user.licenseType }}</span>
        </div>

        <div class="title">
          <div class="label">{{ $t('provider.availability.businessName') }}: </div>
          <div class="value"><a v-bind:href="'/#/provider/' + user.id" target="_blank">{{ user.name }}</a></div>
        </div>

        <div class="title">
          <div class="label">{{ $t('provider.availability.homeSector') }}: </div>
          <div class="value">{{ user.homeSector }}</div>
        </div>

        <div class="title">
          <div class="label">Service: </div>
          <div class="value">{{ user.paxDtd }}</div>
        </div>

        <div class="title">
          <div class="label">{{ $t('provider.availability.vehicle') }}: </div>
          <div class="value">{{ user.vehicleType }}</div>
        </div>

        <div class="title">
          <div class="label">{{ $t('provider.availability.phone') }}: </div>
          <div class="value"> <a @click="call(user)">{{ user.mobile }}</a></div>
        </div>
      </div>
    </div>

    <div class="fix-footer">
        <div class="per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span>per page</span>
        </div>

        <div class="page-data">
          <span v-show="users.length > 0">
            Displaying
            <b>{{ pageData.start }}</b> - <b>{{ pageData.end }}</b> of
            <b>{{ pageData.max }}</b>
          </span>
        </div>

        <div class="pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'driver-table',
  props: ['isMobile'],
  data () {
    return {
      selected: [],
      lastDriver: '',
      modal: {
        tab: 'upcoming',
        trips: [],
        completed: [],
        show: false,
        loading: false,
      },
      checkList: [], // RSVP [upcoming] check list
      checkAll: false,
      tmpData: null
    }
  },
  computed: {
    noShift () { return this.$store.state.provider.availability.noShift },
    users () { return this.noShift.list },
    loading () { return this.$store.state.provider.availability.loading },
    currentOrder () {
      let prov = this.noShift
      return { field: prov.order, asc: prov.orderAsc }
    },
    perPage: {
      get: function () { return this.noShift.perPage },
      set: function (value) {
        this.$store.commit('provider/setAvailabilityNoShiftData', {
          perPage: parseInt(value),
          currentPage: 1
        })
        // this.getList()
      }
    },
    pageData () {
      let tableData = this.noShift
      let start = (tableData.currentPage * tableData.perPage) - (tableData.perPage - 1)
      let end = tableData.currentPage * tableData.perPage
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      }
    },
    currentPage: {
      get: function () { return this.noShift.currentPage },
      set: function (value) {
        this.$store.commit('provider/setAvailabilityNoShiftData', {currentPage: parseInt(value)})
        // this.getList()
      }
    },
    isLastPage () {
      let prov = this.noShift
      return (prov.currentPage * prov.perPage) >= prov.maxList
    },
    totalPage () {
      let prov = this.noShift
      return Math.ceil(prov.maxList / prov.perPage)
    },
    // checked: {
    //   get: function () { return this.$store.state.provider.availability.checked },
    //   set: function (value) {
    //     this.$store.commit('provider/setAvailabilityChecked', value)

    //     let users = []
    //     this.users.forEach(user => {
    //       if (users.indexOf(user.id) === -1) {
    //         users.push(user.id)
    //       }
    //     })
    //     this.checkAll = users.length === value.length
    //   }
    // }
  },
  methods: {
    refreshList () {
      let self = this
      if (self.loading) { return }

      let noShift = JSON.parse(JSON.stringify(this.noShift.list))
      let fieldSort = 'name'
      if (this.noShift.order === 'license') fieldSort = 'licenseType'
      if (this.noShift.order === 'sector') fieldSort = 'homeSector'
      if (this.noShift.order === 'vehicle') fieldSort = 'vehicleType'

      if (this.noShift.orderAsc == 1) noShift.sort((a, b) => a[fieldSort].toLowerCase().localeCompare(b[fieldSort].toLowerCase()))
      else noShift.sort((a, b) => b[fieldSort].toLowerCase().localeCompare(a[fieldSort].toLowerCase()))

      this.$store.commit('provider/setAvailabilityNoShiftData', {list: noShift})
    },
    sort (field) {
      if (this.loading) { return }
      this.checkAll = false
      let prov = this.noShift
      let orderAsc = 1
      if (field === prov.order) orderAsc = prov.orderAsc === 1 ? 0 : 1

      this.$store.commit('provider/setAvailabilityNoShiftData', {
        orderAsc: orderAsc,
        order: field,
        currentPage: 1
      })
      this.refreshList()
    },
    prev () {
      if (this.currentPage === 1) { return }
      this.$store.commit('provider/setAvailabilityNoShiftData', {currentPage: this.noShift.currentPage - 1})
      this.refreshList()
    },
    next () {
      if (this.isLastPage) { return }
      this.$store.commit('provider/setAvailabilityNoShiftData', {currentPage: this.noShift.currentPage + 1})
      this.refreshList()
    },
    call (user) {
      let self = this
      self.$plugins.phone.startCall(self, {
        phone: user.mobile,
        name: user.firstName + ' ' + user.lastName
      })
    },
    toggleCheckAll () {
      if (this.users.length) {
        let users = []
        if (this.checkAll) {
          this.users.forEach(user => {
            if (users.indexOf(user.id) === -1) {
              users.push(user.id)
            }
          })
        }
        this.$store.commit('provider/setAvailabilityChecked', users)
      }
    },
    showDriver (index) {
      let min = (this.noShift.perPage * (this.noShift.currentPage - 1))
      let max = (this.noShift.perPage * this.noShift.currentPage) - 1
      return index >= min && index <= max
    }
  },
  watch: {
    users (val) {
      this.checkAll = false
      this.checkList = []
      val.forEach(driver => {
        this.checkList.push({
          id: driver.id,
          status: 'loading'
        })
      })
    },
    // checkAll (val) {
      
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_status';
.status{
  &.ready{ background: #6dabc3; }
  &.accepted{ background: #777; }
  &.on-time{ background: #26d97a; }
  &.late{ background: #dc9831; }
  &.ontheway{ background: #f38d56; }
  &.very-late{ background: #e62e2e; }
  &.open-credit{ background: #29c3c3; }
}

.list-table.outside{
  border: 1px solid #aaa;
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.sticky{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  overflow: hidden;
  height: 44px;
  z-index: 3;

  tbody{ visibility: hidden; }
}

table{
  border-collapse: collapse;
  width: 100%;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border-bottom: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
    .sortable{
      cursor: pointer;
      color: #333;
      text-decoration: underline;

      i{ margin-left: 2px; }
    }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{ color: #ccc; }
        }
      }
    }
  }

  input{
    display: inline-block;
    width: auto;
  }
  .type{
    display: inline-block;
    padding: 3px 6px;
    text-transform: uppercase;
    border-radius: 4px;
    color: #fff;
    font-size: 11px;
    font-weight: 600;

    &.tnc{ background: #2ab77c; }
    &.tcp{ background: #3f81a0; }
    &.psc{ background: #de6c2a; }
  }
  .city, .phone{}
  .expired{ color: #de2929; }
  .fa-check-circle{ color: #0fda4e; }
  .fa-times-circle{ color: #ef3535; }
  a{ cursor: pointer; }
  .date{ word-spacing: 5px; }
}

.checkbox{
  margin-top: 5px;
  cursor: pointer;
}

.fix-footer{
  width: 100%;
  height: 60px;
  background: #eaeaea;
  border-top: 1px solid #aaa;
  font-size: 13px;
  color: #555;
  display: flex;
  gap: 15px;

  select{ max-width: 100px; }
  .per-page{
    display: flex;
    line-height: 30px;
    padding: 15px 0;
    width: 33%;

    span{
      display: inline-block;
      margin: 0 10px;
    }
  }
  .page-data{
    text-align: center;
    line-height: 30px;
    padding: 15px 0;
    width: 34%;
  }
  .pagination{
    text-align: right;
    padding: 15px 10px;
    width: 33%;

    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;

      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
  }
}

.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0, .5);
  display: none;
  z-index: 12;

  .bg-overlay{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
  }
  .modal-content{
    vertical-align: middle;
    display: none;
    position: relative;
    z-index: 2;

    .list-table{
      padding: 0 25px;
      position: relative;
      overflow: auto;
      max-height: calc(80vh - 115px);
    }
    .content-box{
      width: 800px;
      padding: 25px 0 90px;
      max-height: 80vh;
      min-height: 300px;
      overflow: hidden;
      margin: 0 auto;
      background: #fff;
      text-align: center;
      border-radius: 6px;
      box-shadow: 1px 1px 5px 2px rgba(0,0,0, .3);
      position: relative;

      h1{
        margin: 0 0 10px;
        line-height: 1;
        font-size: 32px;
        color: #434343;
      }
      .main-table{
        border: 1px solid #aaa;
        margin-bottom: 20px;
      }
      a { text-decoration: none; }
      .fa-cube{ margin-left: 3px; }
      .pickup-date{ color: #888; }
      .action {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50px;
        padding: 5px;
        background: #fafafa;
        border-top:1px solid #f3f3f3;

        .button { width: 150px; }
      }
    }
  }
  &.show{
    display: table;

    .modal-content{
      display: table-cell;
      -webkit-animation: slide-down .3s ease-out;
      -moz-animation: slide-down .3s ease-out;
    }
  }
  .close{
    display: block;
    margin-top: 5px;
    font-size: 14px;
    color: #999;
    cursor: pointer;

    &:hover{
      text-decoration: underline;
      color: #555;
    }
  }
}
.res-type{
  display: flex;
  gap: 20px;
  margin-bottom: 10px;

  div{
    color: #bbb;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    &.active{
      color: #2071db;
      border-bottom-color: #2071db;
    }
  }
}

.status{
  text-transform: uppercase;
  letter-spacing: .4px;
  background: #666;
}

@media only screen and (max-width: 430px) {
  .fix-footer {
    .row {
      display: flex;
    }
    .per-page {
      width: auto;
      select {
        width: 55px;
      }
      span:nth-child(3) {
        display: none;
      }
    }
    .page-data {
      display: none;
    }
    .pagination {
      display: flex;
      align-items: center;
      padding: 15px 0px;
      margin-right: 15%;

      select {
        width: 55px;
      }
    }
  }

  .loader, .empty-result {
    text-align: center;
    padding: 50px 0;
  }

  .cards {
    width: 90%;
    margin: 0 auto;
    margin-top: 20px;
    .result-stat {
      width: 100%;
    }
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;

      .info {
        width: 100%;
        padding-left: 10px;
      }

      > div {
        margin-bottom: 3px;
      }

      .email-logo {
        img {
          max-width: 100px;
          max-height: 100px;
        }
      }

      .card-header {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;

        input {
          margin-top: 5px;
          cursor: pointer;
          width: auto;
          margin-right: 5px;
        }

          .type{
            display: inline-block;
            padding: 3px 6px;
            text-transform: uppercase;
            border-radius: 4px;
            color: #fff;
            font-size: 11px;
            font-weight: 600;

            &.tnc{ background: #2ab77c; }
            &.tcp{ background: #3f81a0; }
            &.psc{ background: #de6c2a; }
          }
      }

      .credit-card {
        font-weight: 900;
      }

      .title {
        display: flex;
        align-items: center;
        margin-bottom: 3px;

        input {
          margin-right: 5px;
        }

        &.btn {
          text-align: center;
          justify-content: center;
          margin-top: 15px;
          margin-bottom: 10px;

          .button {
            padding: 10px 20px;
          }
        }
      }


      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
        i {
          color: #bbb;
        }
        a {
          text-decoration: none;
        }
      }
    }
  }

  .modal .modal-content .content-box {
    width: auto;
    padding: 25px 25px 70px;

    h1 {
      font-size: 28px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProviderAvailability/NoShiftTable.vue